"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuTree = exports.menuList = exports.menuEdit = exports.menuDel = exports.menuAdd = exports.getMenuById = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 获取当前登录用户菜单权限表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var menuList = exports.menuList = function menuList(data) {
  return _api.default.request({
    url: '/roleMenu/getMetaMenuTreeListForUser',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取菜单树结构
 * @author kkdy
 * @date 2021-12-01
 * @param {any} data
 * @returns {any}
 */
var menuTree = exports.menuTree = function menuTree(data) {
  return _api.default.request({
    url: '/menu/getMenuListTree',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增菜单或者按钮
 * @author kkdy
 * @date 2021-12-01
 * @param {any} data
 * @returns {any}
 */
var menuAdd = exports.menuAdd = function menuAdd(data) {
  return _api.default.request({
    url: '/menu/addMenu',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除菜单
 * @author kkdy
 * @date 2021-12-01
 * @param {any} data
 * @returns {any}
 */
var menuDel = exports.menuDel = function menuDel(data) {
  return _api.default.request({
    url: '/menu/delMenuById',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 编辑菜单
 * @author kkdy
 * @date 2021-12-01
 * @param {any} data
 * @returns {any}
 */
var menuEdit = exports.menuEdit = function menuEdit(data) {
  return _api.default.request({
    url: '/menu/editMenu',
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑菜单
 * @author kkdy
 * @date 2021-12-01
 * @param {any} data
 * @returns {any}
 */
var getMenuById = exports.getMenuById = function getMenuById(data) {
  return _api.default.request({
    url: '/menu/getMenuById',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};